// ═══════════════════════════════════════════════════════════
//  NETWORK CONFIGURATION - Change ACTIVE_NETWORK to switch
// ═══════════════════════════════════════════════════════════
export const ACTIVE_NETWORK = "mainnet"; // "mainnet" or "testnet"

const networks = {
  mainnet: {
    chainId: 204,
    chainIdHex: "0xCC",
    chainName: "opBNB Mainnet",
    rpcUrl: "https://opbnb-mainnet-rpc.bnbchain.org",
    blockExplorer: "https://opbnbscan.com",
    nativeCurrency: { name: "BNB", symbol: "BNB", decimals: 18 },
    deployBlock: 137147024,
    contracts: {
      token: "0x9e5AAC1Ba1a2e6aEd6b32689DFcF62A509Ca96f3", // USDT on opBNB mainnet
      data: "0x97591140E29a7B67589417aA76112B3f387Abb5D",   // Deploy and fill
      plan1: "0x3eE4838F6FB71EF2A081e85236Aca46Cfd1F3927",  // Deploy and fill
      plan2: "0xCeB2a62f1bd1807c6c97C601407CE0eE7D86E1ea",  // Deploy and fill
    },
  },
  testnet: {
    chainId: 5611,
    chainIdHex: "0x15EB",
    chainName: "opBNB Testnet",
    rpcUrl: "https://opbnb-testnet-rpc.bnbchain.org",
    blockExplorer: "https://testnet.opbnbscan.com",
    nativeCurrency: { name: "tBNB", symbol: "tBNB", decimals: 18 },
    deployBlock: 0, // Set to the block where contracts were deployed
    contracts: {
      token: "0xBf6596a279172D330b8b732D257Ee633B6FDA911",  // Testnet USDT - deploy and fill
      data: "0xf50D5671B6f16bD71273fDA47371b8CBAc7C4368",   // Deploy and fill
      plan1: "0x301d02880B95568755Fa3358C6ee06B7f210262a",  // Deploy and fill
      plan2: "0xCE86E24468502A6Cb9532Ccb8e1B0EC0b7708eA5",  // Deploy and fill
    },
  },
};

export const NETWORK = networks[ACTIVE_NETWORK];
export const TOKEN_DECIMALS = 18;
export const TOKEN_SYMBOL = "USDT";
export const PLAN1_PKG_COUNT = 9;
export const PLAN2_PKG_COUNT = 9;
export const MATRIX_LEVELS = 9;

// ═══════════════════════════════════════════════════════════
//  ABIs
// ═══════════════════════════════════════════════════════════

export const TOKEN_ABI = [
  "function approve(address spender, uint256 amount) external returns (bool)",
  "function allowance(address owner, address spender) external view returns (uint256)",
  "function balanceOf(address account) external view returns (uint256)",
  "function transfer(address to, uint256 value) external returns (bool)",
  "function transferFrom(address from, address to, uint256 value) external returns (bool)",
  "function decimals() external view returns (uint8)",
  "function symbol() external view returns (string)",
];

export const DATA_ABI = [
  // Registration
  "function register(uint256 refId, string calldata name) external",
  "function registerForUser(address wallet, uint256 refId, string calldata name) external",
  "function virtualRegister(address w, uint256 refId, string calldata name) external",
  // Claim
  "function claim() external",
  "function claimAmount(uint256 amt) external",
  "function emergencyWithdraw(uint256 amt) external",
  // Admin setters
  "function setPlan1Contract(address p) external",
  "function setPlan2Contract(address p) external",
  "function setAdmin(address a) external",
  "function transferOwnership(address o) external",
  "function setAdminWallet(address w) external",
  "function setDeductionWallet(address w) external",
  "function setMissingIncomeWallet(address w) external",
  "function setRouter1(address w) external",
  "function setRouter2(address w) external",
  "function setRouter1Enabled(bool e) external",
  "function setRouter2Enabled(bool e) external",
  "function setDefaultReferrer(uint256 uid) external",
  "function blacklistUser(uint256 uid, bool status) external",
  // Read
  "function owner() external view returns (address)",
  "function admin() external view returns (address)",
  "function plan1Contract() external view returns (address)",
  "function plan2Contract() external view returns (address)",
  "function token() external view returns (address)",
  "function adminWallet() external view returns (address)",
  "function deductionWallet() external view returns (address)",
  "function missingIncomeWallet() external view returns (address)",
  "function router1Wallet() external view returns (address)",
  "function router2Wallet() external view returns (address)",
  "function router1Enabled() external view returns (bool)",
  "function router2Enabled() external view returns (bool)",
  "function defaultReferrerId() external view returns (uint256)",
  "function totalUsers() external view returns (uint256)",
  "function addrToId(address) external view returns (uint256)",
  "function claimableBalance(uint256) external view returns (uint256)",
  "function blacklisted(uint256) external view returns (bool)",
  "function isRegistered(uint256 uid) external view returns (bool)",
  "function isBlacklisted(uint256 uid) external view returns (bool)",
  "function getUserWallet(uint256 uid) external view returns (address)",
  "function getUserReferrer(uint256 uid) external view returns (uint256)",
  "function getUserDirectCount(uint256 uid) external view returns (uint256)",
  "function getIdByAddress(address addr) external view returns (uint256)",
  // View (frontend)
  "function getUserInfo(uint256 uid) external view returns (address wallet, uint256 id, uint256 referrerId, string name, uint256 totalInvested, uint256 totalEarned, uint256 totalClaimed, uint256 claimable, uint256 directRefCount, bool active, bool isBL)",
  "function getDirectRefs(uint256 uid, uint256 page, uint256 size) external view returns (uint256[] ids, uint256 total)",
  "function getDirectRefDetails(uint256 upId, uint256 page, uint256 size) external view returns (uint256[] ids, address[] wallets, uint256[] invested, bool[] active_, uint256 total)",
  "function getActivity(uint256 uid, uint256 page, uint256 size) external view returns (tuple(uint256 timestamp, uint256 amount, uint8 actType, uint8 plan, uint8 level, uint256 fromUserId)[] acts, uint256 total)",
  "function getGlobalStats() external view returns (uint256, uint256)",
  "function getRouterStatus() external view returns (bool, bool, address, address)",
  "function getContractBalance() external view returns (uint256)",
  "function getAllUsers(uint256 page, uint256 size) external view returns (uint256[] ids, uint256 total)",
  "function getAllUsersNewest(uint256 page, uint256 size) external view returns (uint256[] ids, uint256 total)",
  // Events
  "event Registered(address indexed wallet, uint256 indexed userId, uint256 indexed refId, string name)",
  "event Claimed(uint256 indexed userId, uint256 amount)",
];

export const PLAN1_ABI = [
  // Public
  "function activatePackage(uint256 pkg) external",
  "function retopup(uint256 pkg) external",
  "function activateForUser(uint256 targetId, uint256 pkg) external",
  "function retopupForUser(uint256 targetId, uint256 pkg) external",
  "function claimDividend(uint256 pkg) external",
  "function claimAllDividends() external",
  "function claimRoyalty() external",
  "function manualAutoUpgrade(uint256 pkg) external",
  // Admin
  "function distributeRoyalty(uint256 amount) external",
  "function withdrawRouterPool(uint256 amount) external",
  "function setAdmin(address a) external",
  "function transferOwnership(address o) external",
  "function setDataContract(address d) external",
  "function setRouter1Pct(uint256 p) external",
  "function setRouter2Pct(uint256 p) external",
  "function setRouterPoolPct(uint256 p) external",
  "function setRouterPoolEnabled(bool e) external",
  "function setCeilingMul(uint256 p) external",
  "function setPkgPrice(uint256 i, uint256 p) external",
  "function setAutoUpgradeEnabled(bool e) external",
  "function setAutoUpgradeMaxDepth(uint256 d) external",
  "function lockMigration() external",
  // View
  "function owner() external view returns (address)",
  "function admin() external view returns (address)",
  "function packages(uint256) external view returns (uint256)",
  "function ceilingMul() external view returns (uint256)",
  "function levelPct() external view returns (uint256)",
  "function divPct() external view returns (uint256)",
  "function adminPct() external view returns (uint256)",
  "function router1Pct() external view returns (uint256)",
  "function router2Pct() external view returns (uint256)",
  "function routerPoolPct() external view returns (uint256)",
  "function routerPoolEnabled() external view returns (bool)",
  "function routerPoolBalance() external view returns (uint256)",
  "function royaltyPoolBalance() external view returns (uint256)",
  "function royaltyEligibleCount() external view returns (uint256)",
  "function autoUpgradeEnabled() external view returns (bool)",
  "function autoUpgradeMaxDepth() external view returns (uint256)",
  "function migrationComplete() external view returns (bool)",
  "function getPackageInfo(uint256 uid, uint256 pkg) external view returns (bool isActive, uint256 baseAmt, uint256 totalInv, uint256 ceil, uint256 earned, uint256 rem, uint256 holdBal)",
  "function getAllPackages(uint256 uid) external view returns (bool[9] a, uint256[9] c, uint256[9] e, uint256[9] r, uint256[9] h)",
  "function getIncomeStats(uint256 uid) external view returns (uint256 lvl, uint256 div, uint256 royalty)",
  "function getPkgIncome(uint256 uid, uint256 pkg) external view returns (uint256 lvl, uint256 div)",
  "function getDivPool(uint256 pkg) external view returns (uint256 dps_, uint256 elig)",
  "function getPendingDiv(uint256 uid, uint256 pkg) external view returns (uint256)",
  "function getAllPendingDiv(uint256 uid) external view returns (uint256[9] p)",
  "function getDivEligibility(uint256 uid) external view returns (bool[9] e)",
  "function getPendingRoyalty(uint256 uid) external view returns (uint256)",
  "function getRoyaltyInfo() external view returns (uint256 pool, uint256 round_, uint256 eligible, uint256 dps_)",
  "function getRouterPoolInfo() external view returns (uint256)",
  "function getMatrixInfo(uint256 uid) external view returns (uint256 parent, bool placed)",
  "function getMatrixUplines(uint256 uid) external view returns (uint256[9] uplines)",
  "function getMatrixLevelCounts(uint256 uid) external view returns (uint256[9] counts)",
  "function getMatrixLevelUsers(uint256 uid, uint256 level, uint256 page, uint256 size) external view returns (uint256[] ids, uint256 total)",
  "function getPackagePrices() external view returns (uint256[9])",
  // Events
  "event Activated(uint256 indexed uid, uint256 pkg, uint256 amt)",
  "event Retopup(uint256 indexed uid, uint256 pkg, uint256 amt, uint256 newCeil)",
  "event LevelIncome(uint256 indexed toId, uint256 indexed fromId, uint256 lvl, uint256 pkg, uint256 amt)",
  "event DividendSettled(uint256 indexed uid, uint256 pkg, uint256 amt)",
  "event AutoUpgrade(uint256 indexed uid, uint256 fromPkg, uint256 toPkg, uint256 amt)",
  "event RoyaltyClaimed(uint256 indexed uid, uint256 amt)",
];

export const PLAN2_ABI = [
  // Public
  "function activatePackage(uint256 pkg) external",
  "function retopup(uint256 pkg) external",
  "function activateForUser(uint256 targetId, uint256 pkg) external",
  "function retopupForUser(uint256 targetId, uint256 pkg) external",
  "function claimDividend(uint256 pkg) external",
  "function claimAllDividends() external",
  "function claimRoyalty() external",
  "function manualAutoUpgrade(uint256 pkg) external",
  // Admin
  "function distributeRoyalty(uint256 amount) external",
  "function withdrawRouterPool(uint256 amount) external",
  "function setAdmin(address a) external",
  "function transferOwnership(address o) external",
  "function setDataContract(address d) external",
  "function setRouter1Pct(uint256 p) external",
  "function setRouter2Pct(uint256 p) external",
  "function setRouterPoolPct(uint256 p) external",
  "function setRouterPoolEnabled(bool e) external",
  "function setAdminPct(uint256 p) external",
  "function setCeilingMul(uint256 p) external",
  "function setPkgPrice(uint256 i, uint256 p) external",
  "function setLevelPct(uint256 lvl, uint256 pct) external",
  "function setAllLevelPcts(uint256[9] pcts) external",
  "function setAutoUpgradeEnabled(bool e) external",
  "function setAutoUpgradeMaxDepth(uint256 d) external",
  "function lockMigration() external",
  // View
  "function owner() external view returns (address)",
  "function admin() external view returns (address)",
  "function packages(uint256) external view returns (uint256)",
  "function ceilingMul() external view returns (uint256)",
  "function globalSharePct() external view returns (uint256)",
  "function directRefPct() external view returns (uint256)",
  "function adminPct() external view returns (uint256)",
  "function router1Pct() external view returns (uint256)",
  "function router2Pct() external view returns (uint256)",
  "function routerPoolPct() external view returns (uint256)",
  "function routerPoolEnabled() external view returns (bool)",
  "function routerPoolBalance() external view returns (uint256)",
  "function royaltyPoolBalance() external view returns (uint256)",
  "function royaltyEligibleCount() external view returns (uint256)",
  "function autoUpgradeEnabled() external view returns (bool)",
  "function autoUpgradeMaxDepth() external view returns (uint256)",
  "function migrationComplete() external view returns (bool)",
  "function getPackageInfo(uint256 uid, uint256 pkg) external view returns (bool isActive, uint256 baseAmt, uint256 totalInv, uint256 ceil, uint256 earned, uint256 rem, uint256 holdBal)",
  "function getAllPackages(uint256 uid) external view returns (bool[9] a, uint256[9] c, uint256[9] e, uint256[9] r, uint256[9] h)",
  "function getIncomeStats(uint256 uid) external view returns (uint256 direct, uint256 lvl, uint256 div, uint256 royalty)",
  "function getPkgIncome(uint256 uid, uint256 pkg) external view returns (uint256 direct, uint256 lvl, uint256 div)",
  "function getDivPool(uint256 pkg) external view returns (uint256 dps_, uint256 elig)",
  "function getPendingDiv(uint256 uid, uint256 pkg) external view returns (uint256)",
  "function getAllPendingDiv(uint256 uid) external view returns (uint256[9] p)",
  "function getDivEligibility(uint256 uid) external view returns (bool[9] e)",
  "function getPendingRoyalty(uint256 uid) external view returns (uint256)",
  "function getRoyaltyInfo() external view returns (uint256 pool, uint256 round_, uint256 eligible, uint256 dps_)",
  "function getRouterPoolInfo() external view returns (uint256)",
  "function getMatrixInfo(uint256 uid, uint256 pkg) external view returns (uint256 parent, bool placed)",
  "function getMatrixUplines(uint256 uid, uint256 pkg) external view returns (uint256[9] uplines)",
  "function getMatrixLevelCounts(uint256 uid, uint256 pkg) external view returns (uint256[9] counts)",
  "function getMatrixLevelUsers(uint256 uid, uint256 pkg, uint256 level, uint256 page, uint256 size) external view returns (uint256[] ids, uint256 total)",
  "function getPackagePrices() external view returns (uint256[9])",
  "function getLevelPercents() external view returns (uint256[9])",
  // Events
  "event Activated(uint256 indexed uid, uint256 pkg, uint256 amt)",
  "event Retopup(uint256 indexed uid, uint256 pkg, uint256 amt, uint256 newCeil)",
  "event DirectRefIncome(uint256 indexed toId, uint256 indexed fromId, uint256 pkg, uint256 amt)",
  "event LevelIncome(uint256 indexed toId, uint256 indexed fromId, uint256 lvl, uint256 pkg, uint256 amt)",
  "event DividendSettled(uint256 indexed uid, uint256 pkg, uint256 amt)",
  "event AutoUpgrade(uint256 indexed uid, uint256 fromPkg, uint256 toPkg, uint256 amt)",
  "event RoyaltyClaimed(uint256 indexed uid, uint256 amt)",
];
